export const state = {
  showGPTChat: false,
  chats: [],
};
